export const urls = {
  GET_VRSTE_ZA_ZAPOSLENOG:
    'DokRNServisniStavkeZaposleni/dok_rn_servisni_vrati_vrste_usluge_stavke_transport',
  GET_ZAPOSLENI_COMBO: 'Combo/vrati_zaposlene_combo',
  VRATI_STAVKE_ZA_RN:
    'DokRNServisniStavkeZaposleni/vrati_stavke_transport_za_dok_rn_servisni',
  INSERT_STAVKE:
    'DokRNServisniStavkeZaposleni/unos_stavke_zaposleni_za_dok_rn_servisni',
  UPDATE_STAVKE:
    'DokRNServisniStavkeZaposleni/izmena_stavke_zaposleni_za_dok_rn_servisni',
  DELETE_STAVKE:
    'DokRNServisniStavkeZaposleni/brisanje_stavke_zaposleni_za_dok_rn_servisni',
  INSERT_DOKUMENTA: 'Dokumenta/unos_dokumenta',
  GET_DOKUMENT: 'Dokumenta/vrati_dokumenta_objekta',
  DELETE_DOKUMENT: 'Dokumenta/brisanje_dokumenta_objekta',
};
